import { render, staticRenderFns } from "./PreselectionsCallToAction.vue?vue&type=template&id=113353ec&scoped=true&"
import script from "./PreselectionsCallToAction.vue?vue&type=script&lang=ts&"
export * from "./PreselectionsCallToAction.vue?vue&type=script&lang=ts&"
import style0 from "./PreselectionsCallToAction.vue?vue&type=style&index=0&id=113353ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113353ec",
  null
  
)

export default component.exports